<div class="main-content" class="dx-viewport">
  <div class="container-fluid">

    <div class="row" [hidden]="loadingVisible">
      <div class="col-md-12 mt-3">
        <div class="row">

          <div class="col-md-3 field-container">
            <form [formGroup]="formC" (ngSubmit)="onSubmit()">
              <mat-form-field appearance="outline">
                <mat-label>
                  Filtrar por cliente:
                </mat-label>
                <mat-select name="clients" [(ngModel)]="clientsFilter" formControlName="clients" multiple
                  (ngModelChange)="$event && onSubmit()">
                  <mat-option *ngFor="let client of clients" [value]="client._id">
                    {{client.firstname}} {{client.lastname}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
            <span class="field-actions" *ngIf="clientsFilter.length > 0">
              <button type="button" class="btn btn-link text-danger mx-0 p-1" (click)="resetFilterC()">
                <i class="material-icons">clear</i>
              </button>
            </span>
          </div>

          <div class="col-md-9">
            <mat-label>

            </mat-label>
            <div>
              Filtrar trabajos por estado: <br>
              <!--<button mat-raised-button class="m-0 ml-1 btn"
                [ngStyle]="{'background-color': colorStatusOpen}" (click)="statusFilter = 'OPEN'; filterAppointments()">ABIERTA</button>-->
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusScheduled}"
                (click)="statusFilter = 'SCHEDULED'; filterAppointments()">Programados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusOnGoing}"
                (click)="statusFilter = 'ONGOING'; filterAppointments()">En Curso</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusCompleted}"
                (click)="statusFilter = 'COMPLETED'; filterAppointments()">Completados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusInvoiced}"
                (click)="statusFilter = 'INVOICED'; filterAppointments()">Facturados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                [ngStyle]="{'background-color': colorStatusCancelled}"
                (click)="statusFilter = 'CANCELLED'; filterAppointments()">Cancelados</button>
              <button mat-raised-button class="m-0 ml-1 p-1 px-2 btn"
                (click)="statusFilter = ''; filterAppointments()">Todos</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div>
          <div>
            <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#calendar' }"
              [(visible)]="loadingVisible" [showIndicator]="true" [showPane]="true" [shading]="true"
              [hideOnOutsideClick]="false">
            </dx-load-panel>
          </div>

          <dx-scheduler appointmentTemplate="appointment-template" [height]="700" [currentDate]="currentDate"
            [dataSource]="appointmentsData" currentView="timelineDay" [startDayHour]="0" [endDayHour]="23"
            [cellDuration]="60" [showAllDayPanel]="false" [groups]="['client']" *ngIf="!loadingVisible"
            (onOptionChanged)="onOptionChanged($event)" (onAppointmentFormOpening)="onAppointmentFormOpening($event)"
            (onContentReady)="onContentReady($event)">
            <dxo-editing #editingOptions [allowAdding]="false" [allowDeleting]="false" [allowUpdating]="false"
              [allowResizing]="false" [allowDragging]="false"></dxo-editing>

            <div *dxTemplate="let appointment of 'appointment-template'"
              [ngStyle]="{ backgroundColor: appointment.targetedAppointmentData.color }">
              <div>
                {{ appointment.targetedAppointmentData.cTitle}}
              </div>
            </div>

            <dxi-view type="timelineDay" name="Día" groupOrientation="vertical"></dxi-view>
            <dxi-view type="workWeek" groupOrientation="vertical"></dxi-view>
            <!--<dxi-view type="month" groupOrientation="horizontal"></dxi-view>-->
            <dxi-resource fieldExpr="client" [dataSource]="clientsV" label="client" [allowMultiple]="false">
            </dxi-resource>
            <dxo-scrolling mode="virtual"> </dxo-scrolling>
          </dx-scheduler>

        </div>
      </div>
    </div>

    <div [hidden]="loadingVisible" class="row">
      <!--<div class="col-md-6">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <h4>Filtro por trabajadores: </h4>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" >
              <mat-label>
                Trabajadores
              </mat-label>
              <mat-select name="workers" [(ngModel)]="workersFilter" formControlName="workers" multiple>
                <mat-option *ngFor="let worker of workers" [value]="worker._id"> 
                  {{worker.lastname}}, {{worker.firstname}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <button mat-raised-button type="submit" class="m-0 ml-1 pull-right btn btn-success">
            Buscar
          </button>
          <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-warning" (click)="resetFilter()">
            Resetear
          </button>
        </div>
      </form>
    </div>-->
      <!--div class="col-md-6">
      <form [formGroup]="formC" (ngSubmit)="onSubmit()">
        <h4>Filtrar por cliente: </h4>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" >
              <mat-label>
                Clientes
              </mat-label>
              <mat-select name="clients" [(ngModel)]="clientsFilter" formControlName="clients" multiple>
                <mat-option *ngFor="let client of clients" [value]="client._id">{{client.firstname}}
                  {{client.lastname}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <button mat-raised-button type="submit" class="m-0 ml-1 pull-right btn btn-success">
            Buscar
          </button>
          <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-warning"
            (click)="resetFilterC()">
            Resetear
          </button>
        </div>
      </form>
    </div-->
      <!--div class="col-md-6">
      <mat-label>

      </mat-label>
      <br>
      <div>
        Ver según estado: <br>
        <button mat-raised-button class="m-0 ml-1 btn" [ngStyle]="{'background-color': colorStatusOpen}"
          (click)="statusFilter = 'OPEN'; filterAppointments()">ABIERTA</button>
        <button mat-raised-button class="m-0 ml-1 btn" [ngStyle]="{'background-color': colorStatusScheduled}"
          (click)="statusFilter = 'SCHEDULED'; filterAppointments()">AGENDADA</button>
        <button mat-raised-button class="m-0 ml-1 btn" [ngStyle]="{'background-color': colorStatusOnGoing}"
          (click)="statusFilter = 'ONGOING'; filterAppointments()">EN PROGRESO</button>
        <button mat-raised-button class="m-0 ml-1 btn" [ngStyle]="{'background-color': colorStatusCompleted}"
          (click)="statusFilter = 'COMPLETED'; filterAppointments()">COMPLETADA</button>
        <button mat-raised-button class="m-0 ml-1 btn" [ngStyle]="{'background-color': colorStatusCancelled}"
          (click)="statusFilter = 'CANCELLED'; filterAppointments()">CANCELADA</button>
        <button mat-raised-button class="m-0 ml-1 btn" (click)="statusFilter = ''; filterAppointments()">VER
          TODOS</button>
      </div>
    </div-->
    </div>
  </div>
</div>